// New custom forms must be imported and exported here to be accessible in the dropdown menu of use custom application.
import { MAAP } from './MAAP/maap';

export const CustomForms = { MAAP };
